import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './countDownTimer.scss';

export default class CountDownTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsLeft: props.time,
      announcement: undefined
    };
  }

  componentDidMount() {
    this.timerId = setInterval(
      () => this.tick(),
      1000
    );
  }

  componentWillUnmount() {
    this.stopCountDown();
  }

  tick = () => {
    if (this.state.secondsLeft === 0) {
      this.stopCountDown();
      this.props.onCountDown();
    } else {
      this.setState((prevState, props) => ({
        secondsLeft: prevState.secondsLeft-1
      }), this.announce);
    }
  }

  announce = () => {
    if (this.state.secondsLeft % 15 === 0) {
      const { minutes, seconds } = this.getMinutesAndSeconds();
      this.setState({
        announcement: `Time Remaining: ${minutes} minutes and ${seconds} seconds`
      });
    }
  }

  getMinutesAndSeconds = () => {
    let min = Math.floor(this.state.secondsLeft / 60);
    let sec = this.state.secondsLeft % 60;
    return { minutes: min, seconds: sec };
  }

  displayMinutesAndSeconds = () => {
    const { minutes, seconds } = this.getMinutesAndSeconds();
    let remainingSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${remainingSeconds}`;
  }

  stopCountDown = () => {
    clearInterval(this.timerId);
  }

  render() {
    return ([
      <div key="announce" aria-live="polite" aria-atomic="true" className="sr-only">
        {this.state.announcement}
      </div>,
      <p key="timer" role="timer">{`Time Remaining: `}
        <time className="countdown-timer">
          {this.displayMinutesAndSeconds()}
        </time>
      </p>
    ]);
  }
}

CountDownTimer.propTypes = {
  time: PropTypes.number.isRequired,
  onCountDown: PropTypes.func.isRequired
};

CountDownTimer.defaultProps = {
  time: 120
};
